module.exports = __webpack_public_path__ + "media/images/icons/up-triangle-disabled-c2710f692ec31eb4d2df46887a6fdf11.svg";